import { Divider, Drawer, Slider, Space, Checkbox, Tooltip } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import ColourPicker from "../../../globals/styles/ColourPicker";
import BMInput from "../../comps/BMInput";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_name_block_warning, tt_yt_padding_x, tt_yt_padding_y, tt_yt_url } from "../../../utils/Utils";
export default function Youtube(props) {
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template, setTemplate] = useTemplate();
    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        url = "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        padding_x = 0,
        padding_y = 0,
        background_colour = 0,
        width = 600,
        aspect_ratio = "16/9",
        align = "center",
        full_width = false,
    } = data;

    const marks = {
        300: <small>300px</small>,
        600: <small>600px</small>,
        900: <small>900px</small>,
        1200: <small>1200px</small>,
    };

    function idFromURL(url) {

        const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
        
        const vimeoRegex = /^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/;
        
        const youtubeMatch = url.match(youtubeRegex);
        const vimeoMatch = url.match(vimeoRegex);

        // If there's a match, return the video ID, else return null
        if (youtubeMatch) {
            return { id: youtubeMatch[1], platform: 'youtube' };
        } else if (vimeoMatch) {
            return { id: vimeoMatch[1], platform: 'vimeo' };
        }
        
        return null;
    }

    const save = () => {
        if(!name){
            let _name = prompt(tt_name_block_warning);
            if(_name){
                close();
                saveItem(id, { ...content, "name" : _name });
            } else {
                return; 
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {

        let _align;
        switch (align) {
            case "center":
                _align = "0 auto"
                break;
            case "right":
                _align = "0 0 0 auto"
                break
            default:
                _align = "0 0 0 0"
        }

        let _wrapperStyle = {
            width: (full_width) ? "100%" : width + "px",
            maxWidth: "100%",
            padding: padding_y + "px " + padding_x + "px",
            margin: _align,
        }

        let _iframeStyle = {
            width: "100%",
            display: "block",
            height: "100%",
            aspectRatio: aspect_ratio
        }

        const videoInfo = idFromURL(url);
        let embedUrl = "";
        
        if (videoInfo) {
            if (videoInfo.platform === 'youtube') {
                embedUrl = `https://www.youtube.com/embed/${videoInfo.id}`;
            } else if (videoInfo.platform === 'vimeo') {
                embedUrl = `https://player.vimeo.com/video/${videoInfo.id}`;
            }
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={{ "background": getColor(background_colour, template) }}>
                    <div style={_wrapperStyle}>
                        <iframe style={_iframeStyle} width="100%" height="100%" src={embedUrl} frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        )

    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} trash={trash} close={close} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* VIDEO URL */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={tt_yt_url}>Youtube/Vimeo URL</Tooltip></Divider>
                <BMInput value={url} width="245px" onChange={(_v) => setData({ ...data, "url": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / FULL WIDTH</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <div>
                        <Checkbox checked={full_width} onChange={(e) => setData({ ...data, "full_width": e.target.checked })} ><small>Full width?</small></Checkbox>
                    </div>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH</Divider>
                <Slider disabled={full_width} defaultValue={width} onChange={(e) => setData({ ...data, "width": e })} marks={marks} min={0} max={1248} />
                <div className="shim" /> <div className="shim" />
                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_yt_padding_x}><PaddingHorizontalIcon style={{"color" : "#888"}} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_yt_padding_y}><PaddingVerticalIcon style={{"color" : "#888"}} /></Tooltip>} />
                    </Space>
                    <div></div>
                </div>
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX" : "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}